import SideNav from "../SideNav";
import { Outlet } from "react-router-dom";
import Header from "../Header";
import Menu from "../Menu";
import styles from "@/static/styles/scrollbar.module.css";
import clsx from "clsx";

function AppLayout() {
  return (
    <div className="bg-slate-50">
      <Header />
      <div className="relative flex h-[calc(100vh-5rem)] bg-white design_screen:mx-auto  design_screen:max-w-screen-design_screen">
        <SideNav
          className={clsx(
            "flex-[0.2] md:flex-[0.15] bg-whitee h-full overflow-y-auto",
            styles.no_scrollbar
          )}
        />
        <div className="flex-[0.8] md:flex-[0.85] min-h-full overflow-y-auto  relative  pt-8 pl-8 overflow-x-hidden ">
          <Menu />
          <Outlet />
        </div>
      </div>
    </div>
  );
}

export default AppLayout;
